// Helper utilities for tenant detection
export function isPlatformAdmin(user) {
  return !!(user?.derived?.isPlatformAdmin || (Array.isArray(user?.roles) && user.roles.includes("platform_admin")));
}

// Detect whether a user belongs to the Medicover tenant.
// Priority: tenant.slug, tenant.code, tenant.key, then tenant.name contains 'medicover'.
// Returns false for platform admins.
export function isMedicoverTenantUser(user) {
  if (!user) return false;
  if (isPlatformAdmin(user)) return false; // do not gate platform admins
  const tenant = user?.tenant || {};

  // Priority checks for stable identifiers
  const checks = [
    tenant?.slug,
    tenant?.code,
    tenant?.key,
    user?.tenant_slug,
    user?.tenant_code,
    user?.tenantCode,
    user?.tenantSlug,
    user?.tenantId,
  ];

  for (const v of checks) {
    if (!v) continue;
    try {
      if (v.toString().toLowerCase() === "medicover") return true;
    } catch {
      // ignore
    }
  }

  // Check tenant name fields
  const nameChecks = [tenant?.name, user?.tenant_name, user?.tenantName, user?.tenantNameDisplay];
  for (const n of nameChecks) {
    if (!n) continue;
    try {
      const s = n.toString().toLowerCase();
      if (s === "medicover" || s.includes("medicover")) return true;
    } catch {
      // ignore
    }
  }

  // Temporary fallback: if no tenant identifiers, use email domain
  const email = (user?.email || "").toString().toLowerCase();
  try {
    const domain = email.split("@")[1] || "";
    if (domain === "medicover.ro") return true;
  } catch {
    // ignore
  }

  return false;
}

const tenantUtils = { isMedicoverTenantUser, isPlatformAdmin };
export default tenantUtils;
